var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouteDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 24,
    viewBox: "0 0 2 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L0.999999 23",
    stroke: "#AA8768",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeDasharray: "3 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteDots);
export default __webpack_public_path__ + "static/media/RouteDots.9c245f80e99eb46acae056edfbcb8fee.svg";
export { ForwardRef as ReactComponent };